import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../../../components/common/BackButton';
import { CourseCreationForm } from '../../../components/admin/courses/CourseCreationForm';
import { createCourse } from '../../../services/admin/courseService';
import { toast } from 'react-hot-toast';
import type { Course } from '../../../types/course';

export function AddCoursePage() {
  const navigate = useNavigate();

  const handleSubmit = async (courseData: Partial<Course>) => {
    try {
      await createCourse(courseData);
      toast.success('Course created successfully');
      navigate('/admin/courses');
    } catch (error) {
      console.error('Error creating course:', error);
      toast.error('Failed to create course');
    }
  };

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4">
        <BackButton to="/admin/courses" label="Back to Courses" />
        
        <div className="bg-background-card rounded-xl border border-gray-800 overflow-hidden">
          <div className="p-6">
            <h1 className="text-2xl font-bold text-white mb-8">Add New Course</h1>
            <CourseCreationForm onSubmit={handleSubmit} />
          </div>
        </div>
      </div>
    </div>
  );
}